import { Breakpoints } from '../constants';
import { css } from 'styled-components';

export const mapBreakpoints = (breakpoints, fn) =>
    Object
        .keys(breakpoints)
        .map(key => css`
            ${breakpoint(key)} {
                ${fn(breakpoints[key])}
            }
        `)
        .reduce((code, breakpoint) => {
            return css`
                ${code}
                ${breakpoint}
            `;
        }, '');

const OrderedBreakpointNames = Object.keys(Breakpoints);
const BreakpointNames = new Set(OrderedBreakpointNames);

const nextBreakpoint = name => {
    const idx = OrderedBreakpointNames.indexOf(name);
    return OrderedBreakpointNames[idx + 1];
};

const toValue = width => {
    if (BreakpointNames.has(width)) {
        return `${Breakpoints[width]}px`;
    }
    if (typeof width === 'string') {
        return width;
    }
    return `${width}px`;
};

const mediaQuery = ({ minWidth, maxWidth } = {}) => {
    let code = '@media screen';

    if (minWidth !== undefined) {
        code = `${code} and (min-width: ${toValue(minWidth)})`;
    }

    if (maxWidth !== undefined) {
        code = `${code} and (max-width: ${toValue(maxWidth)})`;
    }

    return code;
};

const breakpoint = (width, options = {}) => {
    const {
        down,
        only,
    } = options;

    const isNamed = BreakpointNames.has(width);

    if (isNamed) {
        if (down) {
            switch (width) {
                case 'xxlarge':
                    return mediaQuery();

                default:
                    return mediaQuery({
                        maxWidth: Breakpoints[nextBreakpoint(width)] - 1,
                    });
            }
        }

        if (only) {
            switch (width) {
                case 'xxsmall':
                    return mediaQuery({
                        maxWidth: Breakpoints.xsmall - 1,
                    });

                case 'xxlarge':
                    return mediaQuery({
                        minWidth: Breakpoints.xxlarge,
                    });

                default:
                    return mediaQuery({
                        minWidth: Breakpoints[width],
                        maxWidth: Breakpoints[nextBreakpoint(width)] - 1,
                    });
            }
        }
    }

    return mediaQuery({
        minWidth: width,
    });
};

OrderedBreakpointNames.forEach(key => {
    breakpoint[key] = breakpoint(key);
});

export default breakpoint;
